import { render } from "./AIChatProvider.vue?vue&type=template&id=f24b57c0&scoped=true&ts=true"
import script from "./AIChatProvider.vue?vue&type=script&lang=ts"
export * from "./AIChatProvider.vue?vue&type=script&lang=ts"

import "./AIChatProvider.vue?vue&type=style&index=0&id=f24b57c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24b57c0"],['__file',"src/components/AIChat/AIChatProvider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f24b57c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f24b57c0', __exports__)) {
    api.reload('f24b57c0', __exports__)
  }
  
  module.hot.accept("./AIChatProvider.vue?vue&type=template&id=f24b57c0&scoped=true&ts=true", () => {
    api.rerender('f24b57c0', render)
  })

}


export default __exports__